export default class EntityAlreadyExistsException extends Error {
  constructor(message: string) {
    super(message);
  }
}
